<div class="common-text-input__container"
  [id]="field.id">
  <div class="common-text-input__container-box"
    [ngClass]="{'common-text-input__container-box--focused': fieldTypeContacts.showList,
      'common-text-input__container-box--error': field.error}"
    [attr.disabled]="field.noEditable?true:null"
    #containerFieldContact>
    <div class="common-text-input__container-box-inner-list">
      <div class="common-text-input__block-header">
        <div class="common-text-input__label-no-cursor">
          <span class="common-text-input__text-label">{{fieldTypeContacts.titleField}}</span>
          @if(field.required){
            <span class="common-tag__mandatory-text-asterisk">*</span>
          }
          <div class="common-text-input__block-buttons">
            @if (field.description) {
              <tooltip-info [description]="field.description"
              [field]="field"></tooltip-info>
            }
            @if (field.references?.length) {
              <tooltip-law [references]="field.references"
              [field]="field"></tooltip-law>
            }
              @if (field.relatedInfo?.length){
                <button class="common-button__icon-sm-noborder"
                    pTooltip="{{'common.related-info'| afTranslate}}"
                    tooltipPosition="top"
                    (click)="openModalRelatedInfo(field.relatedInfo)">
                    <i class="lf-icon-search-text common-icon__md"></i>
                </button>
              }
              @if (field.inReport !== null && field.inReport !== undefined && !isLanding){
                <tooltip-in-report [inReport]="fieldTypeContacts.inReport"></tooltip-in-report>
              }
          </div>
        </div>
        <div class="common-text-input__buttons-right-header"
          #containerButtonsRightFieldContact>
          @if(!field.meetingSaved && field.multiple && fieldTypeContacts.contactListSelected?.length){
            <div class="common-badge__badge-block">
              <span class="common-badge__square-md">{{fieldTypeContacts.contactListSelected.length}}</span>
            </div>
          }
          @if(field.meetingSaved){
            <div class="common-text-input__buttons-right-header-container">
              <div class="common-badge__badge-block">
                <span class="common-badge__square-color-blue"
                  (click)="selectSign('all', $event)">{{fieldTypeContacts.all}}</span>
              </div>
              <div class="common-badge__badge-block">
                <span class="common-badge__square-color-green"
                  (click)="selectSign('confirm', $event)">{{fieldTypeContacts.confirm}}</span>
              </div>
              <div class="common-badge__badge-block">
                <span class="common-badge__square-color-red"
                  (click)="selectSign('cancel', $event)">{{fieldTypeContacts.cancel}}</span>
              </div>
              <div class="common-badge__badge-block">
                <span class="common-badge__square-color-grey"
                  (click)="selectSign('pending', $event)">{{fieldTypeContacts.pending}}</span>
              </div>
              <list-in-dropdown
                [list]="fieldTypeContacts.participantList"
                [patternId]="'field-type-contacts-participants-list-'+field.id"
                [type]="'meeting'"
                [subtitle]="fieldTypeContacts.selectedSign.title"></list-in-dropdown>
            </div>
          }
          <div class="common-text-input__buttons-right-header-container">
            <button class="common-button__icon-sm-noborder"
              [id]="'button-overlay-contacts-field-'+field.id"
              [disabled]="!fieldTypeContacts.typeView?.length || field.noEditable"
              (click)="toggleFilter($event)">
              <i class="lf-icon-angle-down common-icon__md"
                [ngClass]="fieldTypeContacts.showList?'lf-icon-angle-up':'lf-icon-angle-down'"></i>
            </button>
            <p-overlayPanel #fieldTypeContactsOverlay
              styleClass="common-dropdown-list__overlay-field-list"
              (onShow)="openOverlay()"
              (onHide)="closeOverlay()">
              <ng-template pTemplate="content">
                <div class="common-dropdown-list__overlay-field-list-container"
                  [ngStyle]="{'width': containerFieldContactElement.nativeElement?.offsetWidth+'px'}">
                  <div class="common-tab__tertiary-list-container">
                    @if(fieldTypeContacts.littleDesignTypeView){
                      <button-with-text-menu-arrow
                        [item]="fieldTypeContacts.typeViewItem"
                        [list]="fieldTypeContacts.typeView"
                        [selectedOption]="fieldTypeContacts.selectedView"
                        (launchActionEmitter)="changeView($event.option)">
                      </button-with-text-menu-arrow>
                    }@else {
                      <div class="common-tab__tertiary-list-block common-tab__tertiary-list-block--borderer"
                          [id]="'typeViewContactBlock-'+field.id"
                          [ngStyle]="{'visibility': fieldTypeContacts.configuratedDesignTypeView?'visible':'hidden'}">
                          @for(typeView of fieldTypeContacts.typeView; track typeView.optionAction){
                            <button class="common-tab__tertiary"
                              [ngClass]="{'common-tab__tertiary--selected': typeView.type === fieldTypeContacts.selectedView?.type}"
                              (click)="changeView(typeView)">
                              <p class="common-tab__tertiary-button-text">{{typeView.label}}</p>
                            </button>
                          }
                      </div>
                    }
                  </div>

                  <div class="common-dropdown-list__overlay-header-search-container">
                    <div class="common-search__container-tonal">
                      <div class="common-search__container-input-text">
                        <input type="search"
                          class="common-search__input-text"
                          [(ngModel)]="fieldTypeContacts.searchName"
                          (keyup)="changeList()"
                          placeholder="{{'common.search-item' | afTranslate}}">
                      </div>
                      <div class="common-search__block-button-search">
                        @if(fieldTypeContacts.searchName){
                          <button class="common-button__icon-xs-noborder"
                            (click)="resetSearch()">
                            <i class="lf-icon-close-thick common-icon__sm"></i>
                          </button>
                        }
                        <div class="h-[22px]"
                            ngClass="{{fieldTypeContacts.searchName?'common-divider__vertical-main-1000':'common-divider__vertical-grey-400'}}"></div>
                        <i class="lf-icon-search common-icon__md"
                            ngClass="{{!fieldTypeContacts.searchName?'common-search__icon-search-disabled':'common-search__icon-search-enabled'}}"></i>
                      </div>
                    </div>
                    @if (field.addContacts && fieldTypeContacts.canCreateContacts) {
                      <button class="common-button__icon-md-border"
                        (click)="addNewContact()">
                        <i class="lf-icon-sum common-icon__md"></i>
                      </button>
                    }
                  </div>
                  <div class="common-dropdown-list__overlay-list-container">
                    @if (this.fieldTypeContacts.showToggleAll){
                      <div class="common-dropdown-list__item-value common-dropdown-list__item-value--all"
                        (click)="toggleAll()"
                        [attr.disabled]="field.noEditable?true:null">
                        <div class="common-button__block-button-md-checkbox">
                          <button class="common-button__icon-md-checkbox"
                            [ngClass]="{'common-button__icon-md-checkbox--selected': fieldTypeContacts.markAll}"
                            [disabled]="field.noEditable">
                            <i class="common-icon__md"
                              ngClass="{{fieldTypeContacts.markAll?'lf-icon-check-full':'lf-icon-box-inactive'}}"></i>
                          </button>
                        </div>
                        <span-tooltip class="common-dropdown__list-text-title"
                          [ngClass]="{'common-dropdown__list-text-title--disabled': field.noEditable}"
                          [text]="'common.toggle-all' | afTranslate"
                          [tooltipPosition]="'right'">_Marcar/desmarcar todas las opciones</span-tooltip>
                      </div>
                    }
                    @for (listValue of fieldTypeContacts.allUsersList | byWord: fieldTypeContacts.searchName:fieldTypeContacts.byWord | afOrderBy: fieldTypeContacts.afOrderBy:false; track listValue.uniqueValueId) {
                        @if(fieldTypeContacts.selectedView?.type === 'all' || listValue.typeItem === fieldTypeContacts.selectedView?.type){
                          <div class="common-dropdown-list__user-item"
                            [ngClass]="{'common-dropdown-list__user-item--disabled': listValue.disabled}"
                            [attr.disabled]="(listValue.disabled || field.noEditable)?true:null">
                            <div class="common-button__block-button-md-checkbox">
                              <button class="common-button__icon-md-checkbox"
                                [ngClass]="{'common-button__icon-md-checkbox--selected': listValue.active}"
                                [disabled]="listValue.disabled || field.noEditable"
                                (click)="selectItem(listValue, listValue.typeItem)">
                                <i class="common-icon__md"
                                  [ngClass]="{
                                    'lf-icon-check-full': field.multiple && listValue.active,
                                    'lf-icon-box-inactive': field.multiple && !listValue.active,
                                    'lf-icon-radio-button-active': !field.multiple && listValue.active,
                                    'lf-icon-step-first': !field.multiple && !listValue.active}"></i>
                              </button>
                            </div>
                            <div class="common-dropdown-list__user-item-wrapper"
                              (click)="selectItem(listValue, listValue.typeItem)">
                              <i [ngClass]="{
                                'lf-icon-lead': listValue.typeItem === 'productRole',
                                'lf-icon-group': listValue.typeItem === 'group',
                                'lf-icon-user-special': listValue.typeItem === 'user',
                                'lf-icon-user': listValue.typeItem === 'contact',
                                'common-icon__md-code-color-neutral-grey-600': listValue.disabled
                                }">
                              </i>
                              <span-tooltip class="common-dropdown__list-text-title"
                                [ngClass]="{'common-dropdown__list-text-title--disabled': listValue.disabled}"
                                [text]="listValue.fullName"
                                [tooltipText]="listValue.typeItem === 'productRole'?listValue.disabled || listValue.usersList:''"
                                [tooltipPosition]="'right'"
                                [isDeleted]="listValue.isDeleted"></span-tooltip>
                            </div>
                          </div>
                        }
                    }
                  </div>
                </div>
              </ng-template>
            </p-overlayPanel>
          </div>
        </div>
      </div>
      <div class="common-list__list-group min-h-[22px]"
        [ngClass]="{'common-list__list-group--column': field.multiple && (field.typeConfiguration === 'field-user' || field.typeConfiguration === 'roles' || field.typeConfiguration === 'user-role')}">
        @for (listElement of fieldTypeContacts.contactListSelected; track $index){
          @if (field.typeConfiguration === 'field-user' || field.typeConfiguration === 'roles' || field.typeConfiguration === 'user-role') {
            <div class="common-text-field__container-user-list"
              [attr.disabled]="field.noEditable?true:null">
              <div class="common-text-field__column-user-selected">
                <span-tooltip class="common-chips__label-text"
                  [text]="listElement.fullName"></span-tooltip>
              </div>
              <div class="common-text-field__column-user-selected">
                <span-tooltip class="common-chips__label-text"
                  [text]="listElement.phoneNumber1"></span-tooltip>
              </div>
              <div class="common-text-field__column-user-selected">
                <span-tooltip class="common-chips__label-text"
                  [text]="listElement.email"></span-tooltip>
              </div>
              @if (!field.noEditable) {
                <button class="common-text-input__icon-clean-input"
                  (click)="addOrDeleteMultipleItem(listElement, listElement.typeItem)">
                  <i class="lf-icon-close-thick common-icon__sm"></i>
                </button>
              }
            </div>
          }@else if(field.multiple){
            <div class="common-chips__standard"
                [attr.disabled]="field.noEditable?true:null">
                <span-tooltip class="common-chips__label-text"
                  [text]="listElement.fullName"></span-tooltip>
                @if (!field.noEditable){
                  <button class="lf-icon-close-round common-icon__sm common-chips__icon-close"
                    (click)="selectItem(listElement, listElement.typeItem)"></button>
                }
            </div>
          }@else {
            <div class="common-text-input__block-selected-item"
              [ngClass]="{'common-text-input__block-selected-item--with-value': listElement?.fullName && !field.noEditable}">
              <span-tooltip class="common-text-input__selected-option"
                  [attr.disabled]="field.noEditable?true:null"
                  [text]="listElement?.fullName"></span-tooltip>
              @if (listElement?.fullName && !field.noEditable) {
                <button class="common-text-input__icon-clean-input"
                  (click)="selectItem(listElement, listElement.typeItem)">
                  <i class="lf-icon-close-thick common-icon__sm"></i>
                </button>
              }
            </div>
          }
        }
      </div>
    </div>
    @if(field.meetingSaved){
      <div [id]="'field-type-contacts-participants-list-'+field.id"
        class="common-text-input__container-participant-empty"></div>
    }
  </div>
  @if(field.error){
    <div class="common-text-input__mandatory-tag">
      @if(field.blocker){
        <i class="lf-icon-warning common-icon__error-md"></i>
      }
      <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
    </div>
  }
</div>
